const themeVarMap = {
  primary100: '--color-primary-100',
  primary200: '--color-primary-200',
  primary300: '--color-primary-300',
  primary400: '--color-primary-400',
  primary500: '--color-primary-500',
  primary600: '--color-primary-600',
  primary700: '--color-primary-700',
  danger100: '--color-danger-100',
  danger200: '--color-danger-200',
  danger400: '--color-danger-400',
  danger500: '--color-danger-500',
  danger600: '--color-danger-600',
}

export const defaultTheme = {
  primary100: '#ffedd5',
  primary200: '#fed7aa',
  primary300: '#fdba74',
  primary400: '#fb923c',
  primary500: '#f97316',
  primary600: '#ea580c',
  primary700: '#c2410c',
  danger100: '#fee2e2',
  danger200: '#fecaca',
  danger400: '#f87171',
  danger500: '#ef4444',
  danger600: '#dc2626',
}

export const applyTheme = (theme = {}) => {
  if (typeof window === 'undefined') return

  const root = document.documentElement
  if (!root) return

  const resolvedTheme = { ...defaultTheme, ...theme }

  Object.entries(themeVarMap).forEach(([key, cssVar]) => {
    if (resolvedTheme[key]) {
      root.style.setProperty(cssVar, resolvedTheme[key])
    }
  })
}

